import axios from "@/lib/axios"
import { clearCart, fetchCartItems } from "@/lib/redux/features/cart";
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks";

const useCart = () => {
    const dispatch = useAppDispatch();
  const items = useAppSelector(
    (state) => state.cart.items
  );
  const product_quantities_arr: number[] = items.map(
    (item) => item.quantity
  );
  const product_ids_arr: number[] = items.map((item) => item.product_id);

  const addAllCart = async () => {

    try {
      await axios.post(`api/v2/web/carts/bulk-add`, {
        product_ids_arr,
        product_quantities_arr,
        // influencer_ids_arr: [2]
      })
      dispatch(clearCart())
      dispatch(fetchCartItems())
    } catch (error) {
      console.log(error);
    }
  }
  return {
    addAllCart
  }

}

export default useCart
